export default "__VITE_ASSET__DK_pjIKq__"